import { render, staticRenderFns } from "./zhangHaoSafety.vue?vue&type=template&id=6271c37f&scoped=true&"
import script from "./zhangHaoSafety.vue?vue&type=script&lang=js&"
export * from "./zhangHaoSafety.vue?vue&type=script&lang=js&"
import style0 from "./zhangHaoSafety.vue?vue&type=style&index=0&id=6271c37f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271c37f",
  null
  
)

export default component.exports